import { Box } from '@twilio-paste/core/box';
import { Truncate } from '@twilio-paste/core/truncate';
import { Text } from '@twilio-paste/core/text';
import React from 'react';

export const UserInfoWithTruncation: React.FC<{
  fullName: string;
  email: string;
}> = ({ fullName, email }) => {
  return (
    <Box maxWidth="space30">
      <Text
        as="div"
        fontSize="fontSize40"
        color="colorText"
        fontWeight="fontWeightSemibold"
        lineHeight="lineHeight40"
      >
        <Truncate title={fullName}>{fullName}</Truncate>
      </Text>
      <Text
        as="div"
        fontSize="fontSize30"
        color="colorTextWeak"
        fontWeight="fontWeightLight"
        lineHeight="lineHeight20"
      >
        <Truncate title={email}>{email}</Truncate>
      </Text>
    </Box>
  );
};
